import { guardChildNodeByType, parseChildren } from '@utils/ast';
import { iframeComponentParsers } from './component.iframe.js';
import { imageComponentParsers } from './component.image.js';
import { mediaComponentParsers } from './component.media.js';
import { textComponentDivParser } from './component.text.div.js';
import { textComponentGlossaryWordParsers } from './component.text.glossary-words.js';
import { textComponentHtmlParsers } from './component.text.html.js';
import { textComponentLinkParsers } from './component.text.links.js';
import { parseCaption, parseCaptionDisplayMode } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

const parseTextComponent = (node, context, options) => {
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  const valueNode = Array.from(node.childNodes).find(
    guardChildNodeByType((options == null ? void 0 : options.textNodeName) ?? "Value")
  );
  if (!pm2 || !valueNode) {
    return null;
  }
  const layout = (() => {
    switch (node.getAttribute("elementBoxType")) {
      case "bokstype-1":
        return "box-1";
      case "bokstype-2":
        return "box-2";
      case "bokstype-3":
        return "box-3";
      default:
        return "none";
    }
  })();
  pm2.ribbonIconId = (() => {
    if (layout === "none") {
      return void 0;
    }
    return node.getAttribute(
      (options == null ? void 0 : options.elementIconAttributeName) ?? "elementIconLetter"
    ) ?? void 0;
  })();
  return {
    nodeType: "text-component",
    id: node.getAttribute("id") ?? void 0,
    pm2,
    meta: {
      caption,
      isRichText: node.tagName.toLowerCase() === "complexcontent"
    },
    options: {
      layout,
      autoCenter: node.getAttribute("centerText") === "true",
      isCollapsible: node.getAttribute("isCollapssible") === "true",
      displayCaption: !!parseCaptionDisplayMode(node)
    },
    children: parseChildren(
      valueNode,
      {
        ...textComponentHtmlParsers,
        ...textComponentLinkParsers,
        ...textComponentGlossaryWordParsers,
        ...textComponentDivParser,
        ...imageComponentParsers,
        ...iframeComponentParsers,
        ...mediaComponentParsers,
        ...textComponentParsers
      },
      context.depth + 1
    )
  };
};
const textComponentParsers = {
  complexcontent: parseTextComponent,
  richtext: parseTextComponent,
  simpletext: parseTextComponent
};

export { parseTextComponent, textComponentParsers };
//# sourceMappingURL=component.text.js.map
